import { useState } from 'react';
import Button from '../../../../components/button/Button';
import { NewEditIcon } from '../../../../components/icons';
import { Role } from '../../../../interfaces/User';
import ViewPermissionModal from './ViewPermissionModal';
import CreateRoleModal from './CreateRoleModal';
import { hasPermission } from '../../../../components/dashboard/dashboardpage/utils';
import { useUserProfile } from '../../../../customhooks/useUserProfile';

interface RoleCardProps {
    roles: Role[];
    title: string;
    isCustom?: boolean;
    refetch: () => void;
}

export const RoleCards = ({
    roles,
    title,
    isCustom = false,
    refetch
}: RoleCardProps) => {
    const [viewPermission, setViewPermission] = useState(false);
    const [viewCreateForm, setViewCreateForm] = useState(false);

    const [selectedRole, setSelectedRole] = useState<Role | undefined>(
        undefined
    );

    const { permissions } = useUserProfile();

    return (
        <div className=' p-6 space-y-6'>
            <h2 className='text-lg font-semibold text-[#121926]'>{title}</h2>
            {roles.map((role, idx) => (
                <div
                    key={idx}
                    className='border-b border-gray last:border-none pb-6 last:pb-0 space-y-2'
                >
                    <div className='flex items-start lg:flex-row flex-col justify-between lg:gap-6'>
                        <div className='space-y-1 flex-1'>
                            <h3 className='text-base font-semibold text-[#111322]'>
                                {role.name}
                            </h3>
                            <p
                                className={`text-sm font-light ${
                                    isCustom
                                        ? 'text-[#111322]'
                                        : 'text-gray-600'
                                }`}
                            >
                                {role.description}
                            </p>
                        </div>
                        <div className='flex items-center flex-row-reverse lg:flex-row gap-4 mt-5'>
                            {isCustom &&
                                permissions &&
                                hasPermission({
                                    userPermissions: permissions,
                                    module: 'userManagement',
                                    permissionList: ['manage'],
                                    feature: 'userManagement'
                                }) && (
                                    <div className='relative'>
                                        <Button
                                            className='px-2.5'
                                            text=''
                                            leftIcon={<NewEditIcon />}
                                            variant='secondary'
                                            onClick={() => {
                                                setSelectedRole(role);
                                                setViewCreateForm(true);
                                            }}
                                        />
                                    </div>
                                )}
                            <Button
                                text='View Permissions'
                                variant='secondary'
                                onClick={() => {
                                    setSelectedRole(role);
                                    setViewPermission(true);
                                }}
                            />
                        </div>
                    </div>
                </div>
            ))}
            {viewPermission && (
                <ViewPermissionModal
                    viewPermission={viewPermission}
                    setViewPermission={setViewPermission}
                    role={selectedRole}
                    isCustom={isCustom}
                    setSelectedRole={setSelectedRole}
                />
            )}
            {viewCreateForm && selectedRole && (
                <CreateRoleModal
                    openModal={viewCreateForm}
                    setOpenModal={setViewCreateForm}
                    selectedRole={selectedRole}
                    setSelectedRole={setSelectedRole}
                    refetch={refetch}
                />
            )}
        </div>
    );
};
